<template>
    <div>
        <!-- 内嵌方式：即在父组件中定义一个el-form，然后将下面的表单项嵌入到父组件的form中去-->
        <template v-if="datadicInfo && datadicInfo.fields && inline === true">
            <template v-for="(field,index) in datadicInfo.fields">
                <el-form-item v-if="field.editable" :key="field.name" :label="field.label" :ref="field.name" :prop="field.name" :class="field.cols && field.cols == 2 ? 'form-ite-span2' : ''">
                    <yushu-datadic-field :field="field" :bean.sync="internalFormData" :readony="readonly"></yushu-datadic-field>
                </el-form-item>
            </template>
            <el-col :span="24" style="text-align:right" v-if="typeof this.showButton == 'undefined' || this.showButton == true">
                <el-button type="primary" :loading="loading" @click.native.prevent="onClickSave">确 定</el-button>
            </el-col>
        </template>
        <template v-else-if="datadicInfo && datadicInfo.fields">
            <el-form class="b-form" ref="intervalForm" :rules="formRules" label-width="140px" label-position="right" :model="internalFormData">
                <div :class="cols == 2 ? 'form-double-column' : ''">
                    <template v-for="field in datadicInfo.fields">
                        <el-form-item v-if="field.editable" :key="field.name" :label="field.label" :ref="field.name" :prop="field.name" :class="getClassName(field)">
                            <yushu-datadic-field :field="field" :bean.sync="internalFormData" :readony="readonly"></yushu-datadic-field>
                        </el-form-item>
                    </template>
                    <template v-if="typeof showButton == 'undefined' || showButton == true">
                        <el-form-item>
                            <el-button type="primary" :loading="loading" @click.native.prevent="onClickSave">保 存</el-button>
                            <el-button @click="onCancel">取消</el-button>
                        </el-form-item>
                    </template>
                </div>
            </el-form>
        </template>
    </div>
</template>
<script>
import { getToken } from '@/web-framework/api/token';
import store from "@/public/store";

export default {
    props: ['lazyInit', 'inline', 'fields', 'module', 'title', "cols", 'id', 'saveCallback', 'saveFailedCallback', 'show-button', 'formData', 'rules', 'readonly', 'tableInfo', 'action'],
    components: {
    },
    mounted() {
        this.formRules = this.rules || {};
        if (typeof this.lazyInit == 'undefined' || this.lazyInit === false) {
            this.init();
        }
    },
    data() {
        return {
            loading: false,
            areaObj: {},
            service: '',
            sortedFields: [],
            datadic: '',
            datadicInfo: {}, // 字典信息
            internalFormData: {}, // 表单数据
            fileList: [],
            span: 1,
            formRules: {
            },
            uploadHeaders: {
                'authorization': getToken(),
            }
        }
    },
    methods: {
        async init(datadicInfo, data) {
            this.span = 24 / (typeof this.cols == 'undefined' ? 1 : this.cols);
            if (!datadicInfo && this.module) {
                let p = this.module.split('/');
                this.service = p[1];
                this.datadic = p[p.length - 1];
                this.datadicInfo = await store.dispatch("cache/getDatadic", { serviceName: this.service, datadicName: this.datadic });
            } else if (datadicInfo) {
                this.datadicInfo = datadicInfo;
            }

            let _fields = this.configFields();

            // 获取到所有的外键字段关联数据的异步函数
            this.getForeignAssociationFieldPromiseFunction();

            let tempData = {};
            if (!data && this.id && this.id.length > 0) {
                let dataResult =  await Request.get(`${this.module}/${this.id}`);
                if (dataResult && dataResult.success && dataResult.data) {
                    tempData = dataResult.data;
                }

                if (_fields && _fields.length > 0) {
                    let keys = Object.keys(tempData);
                    _fields.forEach(f => {
                        if (keys.indexOf(f) == -1) {
                            tempData[f] = '';
                        }
                    });
                }

                this.internalFormData = tempData ? tempData : {};
                if (this.formData) {
                    this.internalFormData = {
                        ...this.internalFormData,
                        ...this.formData
                    }
                }
            } else if (!data && (!this.id || this.id.length == 0) && this.formData ) {
                    this.internalFormData = {
                        ...this.formData
                    }
            } else {
                this.internalFormData = {
                    ...this.internalFormData,
                    ...data
                }
            }

            // 转换多图
            this.convertMultiImage();

            // 其他初始化
            this.$nextTick(() => {
                this.initCKEditors();
                this.initUploadFiles();
                this.initArea();
                this.initCheckbox();
            });

        },
        configFields() {
            let _fields = this.getFieldsNameArray();
            let filtered = this.datadicInfo.fields.filter(item => {
                if (item.style && item.style.length > 0) {
                    try {
                        item.style = JSON.parse(item.style);
                    } catch (error) {
                    }
                }

                if (_fields && _fields.indexOf(item.name) != -1) {
                    item.editable = true;
                    return true;
                } else if (!_fields && item.editable == true) {
                    return true;
                } else {
                    return false;
                }
            });

            this.datadicInfo.fields = filtered.map(item => {
                item = {
                    ...item,
                    ...this.getFieldProperty(item.name)
                };
                return item;
            });

            if (_fields && _fields.length > 0) {
                this.datadicInfo.fields = this.Utils.sortbyArray(this.datadicInfo.fields, 'name', _fields);
            }

            if (this.tableInfo) {
                let keys = Object.keys(this.tableInfo);
                for (let key of keys) {
                    for (let index in this.datadicInfo.fields) {
                        if (key == this.datadicInfo.fields[index].name) {
                            this.datadicInfo.fields[index] = {
                                ...this.datadicInfo.fields[index],
                                ...this.tableInfo[key]
                            };
                            break;
                        }
                    }
                }
            }
            this.initRules(this.datadicInfo.fields);
            return this.datadicInfo.fields.map(item => item.name);
        },
        getForeignAssociationFieldPromiseFunction() {
            let p = [];
            let n = [];
            if (this.datadicInfo && this.datadicInfo.fields) {
                this.datadicInfo.fields.forEach((item, index) => {
                    if (item.isOptions && item.optionsFromTable && item.optionsFromTable.length > 0) {
                        p.push(Request.post(item.optionsFromTable, {}));
                        n.push(index);
                    }
                });
            }

            if (p.length > 0) {
                Promise.all(p).then(results => {
                    for (let i = 0; i < n.length; i++) {
                        Vue.set(this.datadicInfo.fields[n[i]], 'options', results[i].data);
                    }
                });
            }
        },
        initCheckbox() {
            if (this.datadicInfo && this.datadicInfo.fields) {
                this.datadicInfo.fields.forEach(field => {
                    if (field.widgetType === 'CheckBox') {
                        Vue.set(this.internalFormData, field.name, this.internalFormData[field.name] ? JSON.parse(this.internalFormData[field.name]) : []);
                    }
                });
            }
        },
        initRules(fields) {
            let _rules = {};
            if (!fields || fields.length == 0) {
                return;
            }
            fields.forEach(ele => {
                _rules[ele.name] = this.createSingleRulesByField(ele)
            });
            this.formRules = _rules;
        },
        createSingleRulesByField(field) {
            if (!field || typeof field !== 'object') {
                return;
            }
            let rules = [];
            switch (field.widgetType) {
                case "SingleLineText":
                case "MultiLineText":
                case "RichTextEditor":
                    rules = [{
                        required: field.required,
                        message: `请输入${field.label}`,
                        trigger: "blur"
                    },
                    {
                        min: field.minLength,
                        max: field.maxLength,
                        message: `长度在 ${field.minLength} 到 ${field.maxLength} 个字符`,
                        trigger: "blur"
                    }
                    ];
                    break;
                case "Number":
                    rules = [{
                        required: field.required,
                        message: `请输入${field.label}`,
                        trigger: "blur"
                    },
                    {
                        type: "number",
                        message: `请输入${field.label}`,
                        trigger: "blur",
                        transform: (value) => Number(value)
                    }
                    ];
                    break;
                case "Radio":
                case "CheckBox":
                case "Date":
                case "DateTime":
                case "DropdownSelect":
                    rules = [{
                        required: field.required,
                        message: `请输入${field.label}`,
                        trigger: "change"
                    }];
                    break;
                case "SingleImageUpload":
                    rules = [{ required: field.required, message: `请选择${field.label}图片`, trigger: 'change' }];
                    break;
                case "PhoneNumber":
                    rules = [{ required: field.required, trigger: 'change', validator: this.checkPhone }];
                    break;
                case "MobileNumber":
                    rules = [{ required: field.required, trigger: 'change', validator: this.checkPhone }];
                    break;
            }
            return rules;
        },
        handleAvatarSuccess(res, file, name, isArray) {
            if (!isArray) {
                Vue.set(this.internalFormData, name, res.data.url);
                Vue.set(this.fileList, name, { name: file.name, fileId: res.data.url, url: this.Utils.getResourceUrl(res.data.url) });
            } else {
                let value = this.internalFormData[name];
                let fileObj = { name: file.name, fileId: res.data.url, url: this.Utils.getResourceUrl(res.data.url) };
                if (!value) {
                    this.internalFormData[name] = [fileObj];
                    Vue.set(this.fileList, name, this.internalFormData[name]);
                } else if (typeof value == "string") {
                    this.internalFormData[name] = JSON.parse(value);
                    this.internalFormData[name].push(fileObj);
                    Vue.set(this.fileList, name, this.internalFormData[name]);
                } else if (this.Utils.isArray(value)) {
                    Vue.set(this.fileList, name, [fileObj])
                    this.internalFormData[name].push(fileObj);
                }
            }
        },
        onClickRemoveImage(file, fileList, field) {
            let array = this.internalFormData[field.name];
            let index = -1;
            for (let i = 0; i < array.length; i++) {
                if (array[i].name == file.name) {
                    index = i;
                    break;
                }
            }
            if (index != -1)
                this.internalFormData[field.name].splice(index, 1);

        },
        resoveUploadKey(name) {
            if (!this.internalFormData[name]) {
                return [];
            } else if (typeof this.internalFormData[name]) {
                return this.internalFormData[name].split(";");
            } else {
                return this.internalFormData[name];
            }
        },
        convertMultiImage() {
            this.datadicInfo.fields.forEach(field => {
                if (field.widgetType === 'MultiImageUpload') {
                    let value = this.internalFormData[field.name];
                    if (!value) {
                        this.internalFormData[field.name] = [];
                    } else if (typeof value == "string") {
                        this.internalFormData[field.name] = JSON.parse(value);
                    }
                }
            });
        },
        initCKEditors() {
            // if (this.datadicInfo && this.datadicInfo.fields) {
            //     this.datadicInfo.fields.forEach(field => {
            //         if (field.widgetType === 'RichTextEditor') {
            //             this.$nextTick(() => {
            //                 this.Utils.initCKEditorField('ckeditor_' + field.name, this.internalFormData[field.name] || '');
            //             });
            //             // 
            //         }
            //     });
            // }
        },
        // 初始化上传文件
        initUploadFiles() {
            if (this.datadicInfo && this.datadicInfo.fields) {
                this.datadicInfo.fields.forEach(field => {
                    if (field.widgetType === 'UploadFile') {
                        if (this.internalFormData[field.name] && this.internalFormData[field.name].length > 0) {
                            Vue.set(this.fileList, field.name, JSON.parse(this.internalFormData[field.name]));
                        }
                    }
                });
            }
        },
        // 初始化地区
        initArea() {
            // if (this.datadicInfo && this.datadicInfo.fields) {
            //     this.datadicInfo.fields.forEach(field => {
            //         if (field.widgetType === 'Area' && this.internalFormData && this.internalFormData[field.name] && this.internalFormData[field.name].length > 0) {
            //             this.internalFormData[field.name] = JSON.parse(this.internalFormData[field.name]);
            //         }
            //     });
            // }
        },
        getData() {
            return this.internalFormData;
        },
        validate(callback) {
            this.$refs.intervalForm.validate(valid => {
                if (valid) {
                    callback(this.internalFormData);
                }
            });
        },
        beforeSave() {
            // 处理富文本编辑器内容
            if (this.datadicInfo && this.datadicInfo.fields) {
                this.datadicInfo.fields.forEach(field => {
                    if (field.widgetType === 'RichTextEditor') {
                        this.internalFormData[field.name] = CKEDITOR.instances['ckeditor_' + field.name].getData();
                    }
                });
            }
        },
        onClickSave() {
            this.beforeSave();
            this.$refs.intervalForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    let saveAction = this.action ? this.action : `${this.module}/save`
                    Request.post(saveAction, this.internalFormData).then(result => {
                        this.loading = false;
                        Request.validateResult(result, () => {
                            this.$message.success("保存成功");
                            if (this.saveCallback)
                                this.saveCallback(result.data);
                        })
                    }).catch(error => {
                        this.loading = false;
                        Request.validateCatchError(error);
                        if (this.saveFailedCallback)
                            this.saveFailedCallback();
                    });
                }
            });
        },
        checkPhone(rule, value, callback) {
            if (rule.required && this.Utils.isNull(value)) {
                return callback(new Error("请输入电话"));
            }

            if (value === "") {
                callback(new Error("请输入电话或手机号码"));
            } else if (this.Utils.notNull(value)) {
                let regPone = null;
                let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/;
                let tel = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
                if (value.charAt(0) == 0) {
                    regPone = tel;
                } else {
                    regPone = mobile;
                }
                if (!regPone.test(value)) {
                    return callback(new Error("请填写座机号码"));
                }
                callback();
            } else {
                callback();
            }
        },
        getFieldsNameArray() {
            if (this.Utils.isNull(this.fields)) {
                return this.fields;
            } else if (this.Utils.isArray(this.fields)) {
                return this.fields;
            } else {
                let keysArray = Object.keys(this.fields);
                return keysArray;
            }
        },
        onFieldChanged(field, value) {
            if (field) {
                this.$emit('fieldChangeCallback', field, value);
            }
        },
        getFieldStyle(field) {
            if (!field.style)
                return {};

            if (this.Utils.isString(field.style)) {
                return JSON.parse(field.style);
            } else {
                return field.style;
            }
        },
        getFieldProperty(fieldName) {
            if (this.fields && !this.Utils.isArray(this.fields) && typeof this.fields == 'object') {
                if (this.fields[fieldName]) {
                    return this.fields[fieldName];
                }
            }
            return undefined;
        },
        hideFields(fieldArray) {
            for (let i = 0; i < this.datadicInfo.fields.length; i++) {
                let field = this.datadicInfo.fields[i];
                if (fieldArray.indexOf(field.name) != -1) {
                    Vue.set(this.datadicInfo.fields[i], "editable", false);
                }
            }
        },
        showFields(fieldArray) {
            for (let i = 0; i < this.datadicInfo.fields.length; i++) {
                let field = this.datadicInfo.fields[i];
                if (fieldArray.indexOf(field.name) != -1) {
                    Vue.set(this.datadicInfo.fields[i], "editable", true);
                }
            }
        },
        changeField(fieldName, newProperty) {
            for (let i = 0; i < this.datadicInfo.fields.length; i++) {
                let field = this.datadicInfo.fields[i];
                if (fieldName == field.name) {
                    Vue.set(this.datadicInfo.fields, i, { ...field, ...newProperty });
                    break;
                }
            }
        },
        getClassName(field) {
            if (this.cols == 2) {
                if (!field.cols || field.cols == 1) {
                    return 'half-row';
                } else if (field.cols && field.cols == 2) {
                    return 'full-row';
                }
            } else {
                return '';
            }
        }
    }
}
</script>
<style lang="less" scoped>
.huxg-datadic-form {
    /deep/.avatar-uploader {
        border: 1px dashed #cdcdcd;
        .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
        }
    }
    .multi-upload {
        display: inline-block;
        margin-right: 10px;
    }
}
/deep/.el-upload-wrapper {
}

.b-form {
    margin-right: 20px;
    .form-double-column {
        display: flex;
        flex-wrap: wrap; /* 允许子元素换行 */
        justify-content: space-between; /* 根据需要调整水平对齐方式 */
        align-items: flex-start; /* 根据需要调整垂直对齐方式 */
        padding: 10px; /* 可以添加内边距，以便与第一个和最后一个子元素有适当的间距 */
        & > .el-form-item {
            flex: 0 0 calc(49% - 10px); /* 25% - (3 * 20px / 4) = 25% - 15px（因为两边都有margin） */
            margin: 0 10px 20px; /* 上、左、右分别为0, 10px, 10px，下为20px */
            box-sizing: border-box; /* 确保padding和border不会增加元素的最终宽度 */
        }
        /* 移除每行最后一个元素的右边距 */
        & > .el-form-item.half-row:nth-child(2n) {
            margin-right: 0;
        }
        /* 如果需要，可以为最后一行的元素添加下边距 */
        & > .el-form-item.half-row:nth-last-child(-n + 2) {
            margin-bottom: 0;
        }
    }
}
.el-form-item.form-ite-span2 {
    flex: 2 !important;
    padding-right: 0px !important;
    margin-right: 0px !important;
}

// 宽度为一半的样式定义
.el-form-item.half-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
    flex: 1 0 50%; /* 第一个值是flex-grow, 第二个是flex-shrink, 第三个是基础宽度 */
    min-width: 50%; /* 确保在收缩时至少有50%的宽度 */
}

// 占据整行的样式
.el-form-item.full-row {
    flex-basis: 100% !important;
    flex-basis: 100%;
    width: 100%;
}
</style>